import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { map, skipWhile } from 'rxjs/operators';
import { IMenuFilter } from '@nimbus-library/features/menu';
import { NimbusLicense } from '@nimbus-global/features/shared/services/domain/models/license.model';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';

export class LicenseFilter implements IMenuFilter<NimbusLicense> {
  public static for(license: NimbusLicense) {
    return { type: LicenseFilter, option: license };
  }

  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
  ) {}

  public validate$(parameter: NimbusLicense): Observable<boolean> {
    return this.permissionManagerService.getPermissionsModel$().pipe(
      skipWhile((permissionModel) => !permissionModel),
      map((permissionModel) => (permissionModel ? permissionModel.hasLicense(parameter) : false)),
    );
  }
}
